import { IconMenu, MenuItem } from "material-ui";
import IconEdit from "material-ui/svg-icons/editor/mode-edit";
import IconMore from "material-ui/svg-icons/navigation/more-horiz";
import IconManageUsers from "material-ui/svg-icons/social/people";
import IconAddUser from "material-ui/svg-icons/social/person-add";
import React from "react";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import colors from "../styles/colors";
import { colorsV2 } from "../styles/colors";
import "../resources/styles/AppListItem.css";
import ButtonTooltip from "../components/common/ButtonTooltip";

const style = {
  itemContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    borderRadius: "10px",
    padding: 10,
    marginBottom: 15,
    marginRight: 15,
    marginTop: 15,
    flexWrap: "wrap",
    width: "300px",
    border: "solid 2px " + colorsV2.darkGray,
  },
  coverContainer: {
    flex: 1,
    display: "flex",
    justifyContent: "center",
  },
  appDetailsContainer: {
    flex: 4,
    alignContent: "flex-start",
    paddingRight: 8,
    paddingLeft: 8,
  },
  appName: {
    color: colorsV2.primary,
    fontSize: 20,
    fontWeight: "900",
    marginBottom: 0,
    textAlign: "center",
  },
  author: {
    color: colors.nileBlue,
    fontSize: 18,
    fontWeight: 600,
    marginBottom: 0,
  },
  description: {
    marginBottom: 0,
    colors: colors.text,
    fontSize: 16,
    lineHeight: "1.5em",
    height: "3em",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  iconButtonsGroup: {
    display: "flex",
    justifyContent: "flex-end",
  },
  iconButton: {
    cursor: "pointer",
    color: colors.primary,
    padding: 5,
    paddingRight: 5,
  },
  buttonStyle: {
    marginRight: 10,
  },
  coverImage: {
    width: 275,
    height: 200,
  },
  cursor: {
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
  },
};

const AppListItem = (props) => (
  <div style={style.itemContainer} className="Applist__card">
    <div style={style.appDetailsContainer}>
      <div
        style={style.cursor}
        onClick={() =>
          props.isPatient
            ? props.openChannel(props.app.appId, props.app.appName)
            : props.editApp(props.app.appId)
        }
      >
        <p
          style={
            (style.appName,
            {
              color: props.whiteLabelSettings.isWhiteLabel
                ? props.whiteLabelSettings.accentColor
                : "",
            })
          }
        >
          {props.app.appName}
        </p>
        <div style={style.coverContainer}>
          <img
            src={
              props.app.coverUrl
                ? props.app.coverUrl
                : props.app.defaultCoverUrl
            }
            style={style.coverImage}
          />
        </div>
        <p
          style={
            (style.author,
            {
              color: props.whiteLabelSettings.isWhiteLabel
                ? colorsV2.codGray
                : "",
            })
          }
        >
          {props.app.author}
        </p>
        <p style={style.description}>{props.app.appDesc}</p>
      </div>

      {!props.isPatient && (
        <div style={style.iconButtonsGroup}>
          <ButtonTooltip title={"Manage Users"} buttonStyle={style.buttonStyle}>
            <IconManageUsers
              style={
                (style.iconButton,
                {
                  color: props.whiteLabelSettings.isWhiteLabel
                    ? colorsV2.codGray
                    : "",
                })
              }
              className={"step_4"}
              onClick={() =>
                props.openChannel(props.app.appId, props.app.appName)
              }
            />
          </ButtonTooltip>

          <ButtonTooltip
            title={"Add New Patient"}
            buttonStyle={style.buttonStyle}
          >
            <IconAddUser
              style={
                (style.iconButton,
                {
                  color: props.whiteLabelSettings.isWhiteLabel
                    ? colorsV2.codGray
                    : "",
                })
              }
              className={"step_3"}
              onClick={() =>
                props.inviteUser(props.app.appId, props.app.appName)
              }
            />
          </ButtonTooltip>

          <ButtonTooltip title={"Edit Channel"} buttonStyle={style.buttonStyle}>
            <IconEdit
              style={
                (style.iconButton,
                {
                  color: props.whiteLabelSettings.isWhiteLabel
                    ? colorsV2.codGray
                    : "",
                })
              }
              className={"step_2"}
              onClick={() => props.editApp(props.app.appId)}
            />
          </ButtonTooltip>

          <IconMenu
            style={{ cursor: "pointer" }}
            className={"step_5"}
            iconButtonElement={
              <IconMore
                color={{
                  color: props.whiteLabelSettings.isWhiteLabel
                    ? colorsV2.codGray
                    : colors.primary,
                }}
              />
            }
          >
            <MenuItem onClick={() => props.subscription(props.app.appId)}>
              Subscription
            </MenuItem>
            <MenuItem
              onClick={() => props.cloneApp(props.app.appId, props.app)}
            >
              Clone
            </MenuItem>
            <MenuItem
              onClick={() =>
                props.removeApp(props.app.appId, props.app.appName)
              }
            >
              Delete
            </MenuItem>
          </IconMenu>
        </div>
      )}
    </div>
  </div>
);

export default AppListItem;



// WEBPACK FOOTER //
// ./src/layout/AppListItem.js